import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import GlobalFootprint from "./Global";

// World map image URL (you can use your own or a CDN)
const worldMapUrl = 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/World_map_-_low_resolution.svg/1200px-World_map_-_low_resolution.svg.png';

// Preload the world map image for effective loading
const preloadWorldMap = new window.Image();
preloadWorldMap.src = worldMapUrl;
const mapBackgroundStyle = {
    backgroundImage: `url(${worldMapUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100vw',
    height: '100vh',
};

// Sample customer reviews data
const reviews = [
    {
        photo: "https://randomuser.me/api/portraits/men/1.jpg",
        name: "John Doe",
        designation: "Software Engineer",
        rating: 5,
        review: "Excellent service! Highly recommended for everyone.",
    },
    {
        photo: "https://randomuser.me/api/portraits/women/2.jpg",
        name: "Jane Smith",
        designation: "Product Manager",
        rating: 4,
        review: "Very satisfied with the quality and support.",
    },
    {
        photo: "https://randomuser.me/api/portraits/men/3.jpg",
        name: "Michael Brown",
        designation: "UX Designer",
        rating: 5,
        review: "Amazing experience, will use again!",
    },
    {
        photo: "https://randomuser.me/api/portraits/women/4.jpg",
        name: "Emily White",
        designation: "Marketing Lead",
        rating: 4,
        review: "Great value for money. Friendly staff.",
    },
    {
        photo: "https://randomuser.me/api/portraits/men/5.jpg",
        name: "Chris Green",
        designation: "Business Analyst",
        rating: 5,
        review: "Quick response and professional approach.",
    },
    {
        photo: "https://randomuser.me/api/portraits/women/6.jpg",
        name: "Sophia Black",
        designation: "HR Manager",
        rating: 4,
        review: "Good experience overall, would recommend.",
    },
    {
        photo: "https://randomuser.me/api/portraits/men/7.jpg",
        name: "David Lee",
        designation: "Sales Executive",
        rating: 5,
        review: "Top-notch service and support.",
    },
    {
        photo: "https://randomuser.me/api/portraits/women/8.jpg",
        name: "Olivia King",
        designation: "Content Writer",
        rating: 5,
        review: "Loved the attention to detail and care.",
    },
    {
        photo: "https://randomuser.me/api/portraits/men/9.jpg",
        name: "James Scott",
        designation: "Operations Manager",
        rating: 4,
        review: "Efficient and reliable, will return.",
    },
    {
        photo: "https://randomuser.me/api/portraits/women/10.jpg",
        name: "Ava Turner",
        designation: "Graphic Designer",
        rating: 5,
        review: "Creative solutions and great communication.",
    },
];

// Helper to render stars
const renderStars = (count) => {
    return (
        <span>
            {Array.from({ length: 5 }).map((_, i) =>
                i < count ? (
                    <span key={i} className="text-warning">&#9733;</span>
                ) : (
                    <span key={i} className="text-secondary">&#9734;</span>
                )
            )}
        </span>
    );
};

const REVIEWS_PER_PAGE = 3;

const CustomerReviews = () => {
    const [startIndex, setStartIndex] = useState(0);

    const handlePrev = () => {
        setStartIndex((prev) => Math.max(prev - REVIEWS_PER_PAGE, 0));
    };

    const handleNext = () => {
        setStartIndex((prev) =>
            Math.min(prev + REVIEWS_PER_PAGE, reviews.length - REVIEWS_PER_PAGE)
        );
    };

    const visibleReviews = reviews.slice(startIndex, startIndex + REVIEWS_PER_PAGE);

    return (
        <div >
        <section className="container my-5" >
            <h2 className="text-center mb-4">Customer Reviews</h2>
            <div className="row">
                {visibleReviews.map((review, idx) => (
                    <div className="col-md-4 mb-4" key={idx}>
                        <div className="card h-100 shadow-sm">
                            <div className="card-body text-center">
                                <img
                                    src={review.photo}
                                    alt={review.name}
                                    className="rounded-circle mb-3"
                                    width="80"
                                    height="80"
                                    style={{ objectFit: "cover" }}
                                />
                                <h5 className="card-title mb-1">{review.name}</h5>
                                <p className="text-muted mb-2">{review.designation}</p>
                                <div className="mb-2">{renderStars(review.rating)}</div>
                                <p className="card-text">"{review.review}"</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="d-flex justify-content-center mt-3">
                <button
                    className="btn btn-outline-primary me-2"
                    onClick={handlePrev}
                    disabled={startIndex === 0}
                >
                    Previous
                </button>
                <button
                    className="btn btn-outline-primary"
                    onClick={handleNext}
                    disabled={startIndex + REVIEWS_PER_PAGE >= reviews.length}
                >
                    Next
                </button>
            </div>
            
        </section>
        </div>
    );
};

export default CustomerReviews;